import { deleteFilter } from "app/common/utilities/search"
import { replaceWith } from "app/common/utilities/string"
import { BrandSearchFilter } from "app/search/codecs"
import { FacetMap } from "app/search/codecs/map"
import { Link } from "blitz"
import { array, option } from "fp-ts"
import { pipe } from "fp-ts/function"
import useTranslation from "next-translate/useTranslation"
import { FC } from "react"
import { MdClose } from "react-icons/md"
import { tw } from "twind"

const displayFacetString = replaceWith("/")(" > ")

interface ActiveSearchFiltersProps {
  createUrl: (filters: BrandSearchFilter[]) => string
  facetMap: FacetMap
  filters: BrandSearchFilter[]
}

export const ActiveSearchFilters: FC<ActiveSearchFiltersProps> = ({
  createUrl,
  facetMap,
  filters,
}) => {
  const { t } = useTranslation("common")

  return (
    <div className={tw(`flex(& col) gap-4`)}>
      <span className={tw(`font-semibold`)}>{t("filter-by")}:</span>

      <ul className={tw(`flex(& col) gap-1`)}>
        {pipe(
          filters,
          array.map((filter) =>
            pipe(
              facetMap[filter.field],
              array.findFirst((facet) => facet.value === filter.value),
              option.map((targetFacet) => (
                <li
                  className={tw(
                    `flex items-center justify-between gap-2`,
                    `text-sm`,
                    `whitespace-nowrap`
                  )}
                  key={filter.field}
                >
                  <span>
                    <span className={tw(`font-bold`)}>{t(filter.field)}: </span>

                    {displayFacetString(targetFacet.name)}
                  </span>

                  <Link href={pipe(filters, deleteFilter({ field: filter.field }), createUrl)}>
                    <a className={tw(`text(blue-800 hover:red-500)`)}>
                      <MdClose className={tw(`text-base`)} />
                    </a>
                  </Link>
                </li>
              )),
              option.getOrElse(() => <></>)
            )
          )
        )}
      </ul>
    </div>
  )
}
